(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ik-world-page"]) return;
  try {
    
  function rememberInksakeWorld() {
    const world = document.querySelector('[data-ik-world-page]');
    if (!world || !world.dataset.worldHandle || !world.dataset.worldPath) return;
    try {
      sessionStorage.setItem('ik-world-context', JSON.stringify({
        path: world.dataset.worldPath,
        name: world.dataset.worldName,
        handle: world.dataset.worldHandle
      }));
    } catch {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rememberInksakeWorld, { once: true });
  } else {
    rememberInksakeWorld();
  }
  document.addEventListener('shopify:section:load', rememberInksakeWorld);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inksake-retail-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('inksake-hero-rotation')) {
  customElements.define('inksake-hero-rotation', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.stage = this.querySelector('.inksake-hero-rotation__stage');
      this.toggle = this.querySelector('[data-hero-toggle]');
      this.count = this.querySelector('[data-hero-count]');
      this.status = this.querySelector('[data-hero-status]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovering = false;
      this.inView = true;
      this.index = 0;
      this.request = 0;
      this.initial = this.stage.firstElementChild.cloneNode(true);
      const candidates = [...this.closest('.inksake-retail-hero').querySelectorAll('template[data-hero-product]')].filter(item => item.dataset.heroProduct !== this.dataset.initialId);
      let seed = Math.floor(Math.random() * 2147483646) + 1;
      try {
        const key = 'inksake-hero-seed-v1';
        const saved = Number(sessionStorage.getItem(key));
        if (Number.isInteger(saved) && saved > 0 && saved < 2147483647) seed = saved;
        else sessionStorage.setItem(key, String(seed));
      } catch {}
      const random = () => { seed = seed * 16807 % 2147483647; return (seed - 1) / 2147483646; };
      for (let i = candidates.length - 1; i > 0; i--) {
        const j = Math.floor(random() * (i + 1));
        [candidates[i], candidates[j]] = [candidates[j], candidates[i]];
      }
      const families = new Set();
      const varied = [];
      const remaining = [];
      for (const item of candidates) {
        const family = item.dataset.heroFamily || item.dataset.heroProduct;
        if (families.has(family)) remaining.push(item);
        else { families.add(family); varied.push(item); }
      }
      this.slides = [this.initial, ...[...varied, ...remaining].slice(0, 9).map(item => item.content.firstElementChild)];
      if (this.slides.length < 2) return;
      this.querySelector('.inksake-hero-rotation__controls').hidden = false;
      this.toggle.addEventListener('pointerdown', () => { this.toggleIntent = !this.paused; }, { signal });
      this.toggle.addEventListener('pointercancel', () => { this.toggleIntent = undefined; }, { signal });
      this.toggle.addEventListener('click', event => { this.paused = event.detail > 0 && this.toggleIntent !== undefined ? this.toggleIntent : !this.paused; this.toggleIntent = undefined; this.sync(); }, { signal });
      this.querySelector('[data-hero-previous]').addEventListener('click', () => this.move(-1, true), { signal });
      this.querySelector('[data-hero-next]').addEventListener('click', () => this.move(1, true), { signal });
      this.addEventListener('focusin', () => { this.paused = true; this.sync(); }, { signal });
      this.addEventListener('mouseenter', () => { this.hovering = true; this.sync(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovering = false; this.sync(); }, { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, { signal });
      this.stage.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') this.touch = { x: event.clientX, y: event.clientY }; }, { signal, passive: true });
      this.stage.addEventListener('pointercancel', () => { this.touch = null; }, { signal });
      this.stage.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.suppressClickUntil = Date.now() + 500;
          const rtl = getComputedStyle(this).direction === 'rtl';
          this.move((dx < 0 ? 1 : -1) * (rtl ? -1 : 1), true);
        }
      }, { signal });
      this.stage.addEventListener('click', event => { if (Date.now() < (this.suppressClickUntil || 0)) event.preventDefault(); }, { signal });
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold: 0.25 });
      this.observer.observe(this);
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      if (!this.slides || this.slides.length < 2) return;
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.dataset.paused = String(this.paused);
      this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (!this.paused && !this.hovering && this.inView && !document.hidden) this.timer = setTimeout(() => this.move(1, false), 8000);
    }
    async move(direction, manual) {
      if (manual) this.paused = true;
      clearTimeout(this.timer);
      const request = ++this.request;
      const next = (this.index + direction + this.slides.length) % this.slides.length;
      const slide = document.importNode(this.slides[next], true);
      const image = slide.querySelector('img');
      image.loading = 'eager';
      image.fetchPriority = 'low';
      try { await image.decode(); } catch { if (request === this.request && this.isConnected) this.sync(); return; }
      if (request !== this.request || !this.isConnected) return;
      if (!manual && (this.paused || this.hovering || !this.inView || document.hidden)) { this.sync(); return; }
      this.stage.replaceChildren(slide);
      this.index = next;
      if (manual) this.status.textContent = slide.getAttribute('aria-label');
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      clearTimeout(this.timer);
      this.request++;
    }
  });
}

if (!customElements.get('inksake-assortment')) {
  customElements.define('inksake-assortment', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.inksake-assortment__track');
      const controls = this.querySelector('.inksake-assortment__controls');
      const buttons = [...controls.querySelectorAll('button')];
      const rtl = getComputedStyle(track).direction === 'rtl';
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max <= 2;
        buttons[0].disabled = Math.abs(track.scrollLeft) <= 2;
        buttons[1].disabled = Math.abs(track.scrollLeft) >= max - 2;
      };
      const move = direction => track.scrollBy({left: direction * (rtl ? -1 : 1) * track.clientWidth * .8, behavior: 'instant'});
      buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), {signal}));
      track.addEventListener('scroll', update, {passive: true, signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          track.scrollTo({left: event.key === 'Home' ? 0 : track.scrollWidth * (rtl ? -1 : 1), behavior: 'instant'});
        }
      }, {signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
